import {authRequest} from './index.js'


export async function get_reward_history(reward_history_tag){
  let data
  await authRequest.get(
    'reward_histories/' + reward_history_tag
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_reward_history(reward_history){
  let data
  await authRequest.post(
    '/reward_histories',
    { reward_history },
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

// export async function delete_reward_history(reward_history_id){
//   let data
//   await authRequest.delete(
//     '/reward_histories/' + reward_history_id
//   )
//   .then(function(result){
//     data = {result, error: false}
//   })
//   .catch(function (error){
//     console.log(error)
//     data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
//   })
//   return data
// }

export async function update_reward_history(reward_history_id, reward_history){
  let data
  await authRequest.patch(
    '/reward_histories/' + reward_history_id,
    { reward_history },
    { headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_reward_histories(user_id){
  let data
  await authRequest.get(
    `user/${user_id}/reward_histories`
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_reward_total(user_id){
  let data
  await authRequest.get(
    `user/${user_id}/reward_total`
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}